import { useEffect, useState } from "react";
import { t } from "i18next";
import { Tag, Button, Modal } from "antd";
import { EyeOutlined } from "@ant-design/icons";
import DataGrid from "../../core/components/data-grid/DataGrid";
import { useDataGrid } from "../../core/components/data-grid/DataGridContext";
import Helper from "../../core/Helper";
import ApiService from "../../core/service/ApiService";

const EVENT_LABELS = {
    APPOINTMENT_CREATED: 'Randevu Oluşturma',
    APPOINTMENT_REMINDER: 'Randevu Hatırlatma',
    APPOINTMENT_RESCHEDULED: 'Randevu Zaman Değişikliği',
    APPOINTMENT_COMPLETED: 'Randevu Tamamlandı',
    APPOINTMENT_CANCELLED: 'Randevu İptal',
};

const CHANNEL_LABELS = { 1: 'SMS', 2: t('Email'), 4: t('WhatsApp') };

const statusTag = (status) => {
    switch (status) {
        case 1: return <Tag color="success">{t('Sent')}</Tag>;
        case 2: return <Tag color="error">{t('Failed')}</Tag>;
        case 3: return <Tag>{t('Skipped')}</Tag>;
        default: return <Tag color="processing">{t('Pending')}</Tag>;
    }
};

export default function NotificationOutboxGrid() {
    const { queryModel, setDataGridProps, setData, setPaginationResult } = useDataGrid();
    const [detail, setDetail] = useState(null);

    useEffect(() => {
        setDataGridProps({
            rowKey: 'id',
            columns: [
                {
                    dataIndex: 'createdDate', key: 'createdDate', title: t('Date'), sorter: true, width: 150,
                    render: (val) => Helper.Date.dateFormat(val)
                },
                { dataIndex: 'eventType', key: 'eventType', title: t('Notification Type'), width: 180, render: (v) => t(EVENT_LABELS[v] || v) },
                { dataIndex: 'channel', key: 'channel', title: t('Channel'), width: 90, render: (v) => CHANNEL_LABELS[v] || v },
                { dataIndex: 'recipient', key: 'recipient', title: t('Recipient'), width: 150, render: (v) => v || '-' },
                { dataIndex: 'status', key: 'status', title: t('Status'), width: 110, render: (v) => statusTag(v) },
                { dataIndex: 'sentDate', key: 'sentDate', title: t('Sent Date'), width: 150, render: (v) => v ? Helper.Date.dateFormat(v) : '-' },
                { dataIndex: 'attempts', key: 'attempts', title: t('Attempts'), width: 80, render: (v) => v ?? 0 },
                {
                    key: 'detail', title: '', width: 110, align: 'center',
                    render: (_, row) => <Button size="small" icon={<EyeOutlined />} onClick={() => setDetail(row)}>{t('View')}</Button>
                },
            ]
        })
    }, [])

    const load = async () => {
        const res = await ApiService.NotificationSettings.GetOutboxDataGrid(queryModel);
        if (res.success) {
            setData(res.data)
            setPaginationResult(res.pagination);
        }
    }

    useEffect(() => { load() }, [queryModel.updateKey])

    return (
        <>
            <DataGrid />
            <Modal
                open={!!detail}
                title={t('Notification Detail')}
                onCancel={() => setDetail(null)}
                footer={<Button onClick={() => setDetail(null)}>{t('Close')}</Button>}
                width={720}
            >
                <div style={{ fontWeight: 600, marginBottom: 4 }}>{t('Message content')}</div>
                <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word', background: '#f5f5f5', padding: 8, borderRadius: 4 }}>
                    {detail?.renderedBody || '-'}
                </pre>
                {detail?.error && (
                    <>
                        <div style={{ fontWeight: 600, margin: '12px 0 4px' }}>{t('Error')}</div>
                        <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word', color: '#cf1322', background: '#fff1f0', padding: 8, borderRadius: 4 }}>
                            {detail.error}
                        </pre>
                    </>
                )}
                <div style={{ fontWeight: 600, margin: '12px 0 4px' }}>{t('Provider Response')}</div>
                <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word', background: '#f5f5f5', padding: 8, borderRadius: 4, maxHeight: 280, overflow: 'auto' }}>
                    {detail?.providerResponse || '-'}
                </pre>
            </Modal>
        </>
    )
}
